import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Collapse } from '@mui/material';
import SMCButton from '../SMCButton';
import infoIcon from '../../../assets/images/alerts.png';
import SMCNote from '../SMCNote';

/**
 * @param {Object} props
 * @param {Node} [props.children]
 * @param {('note'|'warning'|'error')} [props.variant]
 * @param {Object} [props.style]
 * @param {String} [props.className]
 * @param {Boolean} [props.toggleBool]
 * @param {Function} [props.toggleFunc]
 * @param {Boolean} [props.disabled]
 */
function SMCCollapsibleNote({
    children, //Text/Conent
    variant, // variant of SMCNote
    style, //design
    disabled, //if the page is disabled, the component is disabled as well
    toggleBool, //Boolean for the function that collapses the page
    toggleFunc //The function that collapses the page
}) {
    const classes = useStyles();


    return (
        <Collapse in={toggleBool} unmountOnExit>
        <SMCNote 
            variant = {variant}
            style = {style? style: classes}
        >
            <SMCButton
                        variant="ghost"
                        onClick={toggleFunc}
                        icon = {'clear'}
                        disabled = {disabled}
                            style={{background: 'none', border: 'none',  float: 'right', height: '100%'}}
                          >
            </SMCButton>  
            <img alt="" src={infoIcon} width="13px" height="13px" style={{paddingRight: "10px"}}></img>
            {children}
        </SMCNote>
        </Collapse>
    );
}

const useStyles = makeStyles({
    root: {
        border: '1px solid #d8dee1',
        padding: '5px 15px',
        boxSizing: 'border-box',
        textAlign: "left",
        position:'relative', 
        height:'10%', 
        float:'right', 
        backgroundColor: '#f8f8f8', 
        minHeight: '100%',
        overflow: 'auto',  
        width: '100%',
        verticalAlign: 'middle', 
        margin:'auto'
    },
    note: {
        backgroundColor: '#B1DBFF',
    },
    warning: {
        fontWeight: 'bold',
        backgroundColor: '#fcf9d5',
    },
    error: {
        backgroundColor: '#f86060',
    }
})

SMCCollapsibleNote.propTypes = {
    variant: PropTypes.oneOf(['note', 'warning', 'error']),
    children: PropTypes.node,
    style: PropTypes.object,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    toggleBool: PropTypes.bool,
    toggleFunc: PropTypes.func
}

export default SMCCollapsibleNote;